<template>
  <ValidationProvider v-slot="{ failed, errors, valid, touched }" :rules="rules" :name="name" :vid="vid">
    <div class="form-group" :style="{ marginBottom }">
      <label v-if="label" class="form-control-label" v-html="label" />
      <div v-if="!hideInput" class="input-group input-group-merge">
        <input
          v-if="type === 'number'"
          ref="input"
          v-model="iValue"
          step="any"
          :name="name"
          :placeholder="placeholder"
          :type="type"
          :readonly="readonly"
          :disabled="disabled"
          :autocomplete="autocomplete"
          class="form-control"
          :class="{ 'is-invalid': failed }"
          :accept="accept"
          inputmode="numeric"
          pattern="[0-9]*"
          @change="handleChanged"
          @focus="handleFocus"
        />
        <input
          v-else
          ref="input"
          v-model="iValue"
          :name="name"
          :placeholder="placeholder"
          :type="type"
          :readonly="readonly"
          :disabled="disabled"
          :autocomplete="autocomplete"
          class="form-control"
          :class="{
            'is-invalid': failed,
            'is-valid': valid && touched,
          }"
          :accept="accept"
          @change="handleChanged"
          @focus="handleFocus"
          @keyup="handleKeypress"
        />
        <b-form-invalid-feedback v-if="errors.length">{{ errors[0] }}</b-form-invalid-feedback>
      </div>
      <span v-if="help" class="help-block"><small>{{ help }}</small></span>
    </div>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    value: { required: false, type: [String, Number], default: '' },
    name: { type: String, default: '' },
    autocomplete: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    label: { type: String, default: '' },
    sublabel: { type: String, default: '' },
    type: { type: String, default: 'text' },
    vid: { type: String, default: '' },
    rules: { type: [String, Object], default: '' },
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    accept: { type: String, default: '' },
    help: { type: String, default: '' },
    hideInput: { type: [String, Boolean], default: false },
    marginBottom: { type: String, default: '1rem' }
  },
  computed: {
    iValue: {
      get() { return this.value },
      set(newValue) {
        if (this.type !== 'file') {
          if (this.rules && this.rules.match(/(email|customurl|subdomain)/)) newValue = newValue.replace(/\s/, '')
          this.$emit('input', newValue)
        }
      }
    }
  },
  methods: {
    handleFocus() {
      this.$emit('focus')
    },
    handleChanged() {
      if (this.type === 'file' && this.$refs.input.files.length) this.$emit('changed', this.$refs.input.files[0])
      else this.$emit('changed', this.iValue)
    },
    handleKeypress() {
      this.$emit('keypress', this.$refs.input.value)
    }
  }
}
</script>